(function ($) {
    $.fn.autoScroll = function (options) {
        const that     = this,
              settings = $.extend({
                  'duration': '400',
                  'paddingTop': '0',
                  'callback': null,
                  'scrollable': $('html, body')
              }, options || {});

        let offset = $(this).offset();
        if (offset) {
            offset       = parseInt(offset.top) - parseInt(settings.paddingTop);
            let html$    = settings.scrollable,
                overflow = html$.css('overflow-y');

            html$.css('overflow-y', 'visible');
            html$.animate({scrollTop: offset}, settings.duration, function () {
                if ($.isFunction(settings.callback)) {
                    settings.callback(that);
                }
            });
            $('html').css('overflow-y', overflow);
        }
        return this;
    }
})(jQuery);
